<template>
  <base-table
    title="Companies"
    titleSingle="Company"
    :headers="headers"
    :items="companys"
    :valid="valid"
    :loading="loading"
    add
    @get-items="getCompanys"
    @put-item="putCompanys"
    @post-item="postCompanys"
    @edit-item="editCompanys"
    @delete-item="deleteCompanys"
    @modal-close="resetForm"
  >
    <v-form ref="form" v-model="valid">
      <v-text-field
        v-model="company.name"
        :rules="[v => !!v || 'Name is required']"
        label="Name"
        required
      ></v-text-field>
    </v-form>
  </base-table>
</template>

<script>
import CompanyService from "@/services/CompanyService.js";
import BaseTable from "@/components/tables/BaseTable.vue";

export default {
  name: "CompanyTable",
  components: {
    BaseTable
  },
  data() {
    return {
      headers: [
        { text: "Name", value: "name" },
        { text: "Actions", value: "action" }
      ],
      companys: [],
      company: {
        companyId: "",
        name: ""
      },
      valid: true,
      loading: true
    };
  },
  methods: {
    async getCompanys() {
      this.loading = true;
      try {
        this.companys = await CompanyService.getCompanies();
      } finally {
        this.loading = false;
      }
    },
    putCompanys() {
      if (this.$refs.form.validate()) {
        CompanyService.putCompany(this.company).then(() => {
          this.getCompanys(),
            this.$snackbarSuccess("Company Successfully Edited");
        });
      }
    },
    postCompanys() {
      if (this.$refs.form.validate()) {
        CompanyService.postCompany(this.company).then(() => {
          this.getCompanys(),
            this.$snackbarSuccess("Company Successfully Added");
        });
      }
    },
    editCompanys(item) {
      this.company = Object.assign({}, item);
    },
    deleteCompanys(item) {
      CompanyService.deleteCompany(item.companyId).then(() => {
        this.getCompanys(), this.$snackbarSuccess("Company Deleted");
      });
    },
    resetForm() {
      // Doesn't clear everything since an edit pulls in extra fields
      // Does that matter?
      this.$refs.form.reset();
    }
  }
};
</script>

<style scoped></style>
